import type {ListMaterialFunctionsSearch} from "./-types";

import {listMaterialFunctionsQueryOptions} from "@project/application/engineering/material-functions";
import {AppErrorBoundary} from "@project/layouts";
import {createFileRoute} from "@tanstack/react-router";

import {MaterialFunctionsPage} from "./-page/material-functions.page";
import {MaterialFunctionsPending} from "./-page/material-functions.pending";
import {listMaterialFunctionsSearchSchema} from "./-types";

export type {ListMaterialFunctionsSearch} from "./-types";

export const Route = createFileRoute("/_app/engineering/materials/functions/")({
  component: MaterialFunctionsPage,
  errorComponent: AppErrorBoundary,
  loader: async ({context: {queryClient}, deps, cause}) => {
    if (cause === "enter") {
      return queryClient.ensureQueryData(
        listMaterialFunctionsQueryOptions(deps as ListMaterialFunctionsSearch),
      );
    }

    void queryClient.prefetchQuery(
      listMaterialFunctionsQueryOptions(deps as ListMaterialFunctionsSearch),
    );

    return;
  },
  loaderDeps: ({search}) => search,
  pendingComponent: MaterialFunctionsPending,
  staticData: {meta: {breadcrumbs: {hide: true}}},
  validateSearch: (search) => listMaterialFunctionsSearchSchema.parse(search),
});
